/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Faq_Q4Inputs */

const en_pc_alt_faq_q4 = /** @type {(inputs: Pc_Alt_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which PdfCraft alternatives work on Linux?`)
};

const zh_pc_alt_faq_q4 = /** @type {(inputs: Pc_Alt_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哪些 PdfCraft 替代品能在 Linux 上使用？`)
};

/**
* | output |
* | --- |
* | "Which PdfCraft alternatives work on Linux?" |
*
* @param {Pc_Alt_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_faq_q4 = /** @type {((inputs?: Pc_Alt_Faq_Q4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Faq_Q4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_faq_q4(inputs)
	return zh_pc_alt_faq_q4(inputs)
});
export { pc_alt_faq_q4 as "pc.alt.faq.q4" }